<template>
  <LocationCell
    :country="country?.name ?? '-'"
    :country-code="country?.isoCode ?? null"
    :detail="cityDetails"
    :title="country?.name ?? '-'"
    no-icon-fallback
    xs
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import LocationCell from '@/components/LocationCell.vue'
import { extractCityDetailsFormatted } from '@/components/Employments/Partner/EmploymentExportConfig'

const EmploymentLocationColumn = graphql(`
  fragment EmploymentLocationColumn on Employment {
    id
    worker {
      id
      address {
        city
        state
        country {
          isoCode
          name
        }
      }
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof EmploymentLocationColumn> }>()
const column = computed(() => useFragment(EmploymentLocationColumn, props.row))

const country = computed(() => column.value.worker?.address?.country)

const cityDetails = computed(() => extractCityDetailsFormatted(column.value))
</script>
